import React, { useState, useEffect, useRef } from "react";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import adminService from "../../../services/AdminService";

const CreateUserModal = (props) => {
  const { show, onHide, roles } = props;

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [roleId, setRoleId] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const [errorText, setErrorText] = useState("");

  let errorLabel =
    errorText && errorText.length > 0 ? (
      <span className="text-danger">{errorText}</span>
    ) : (
      <></>
    );

  const dropdownRoleRef = useRef(null);

  useEffect(() => {
    if (roles) {
      setRoleId(roles[0].id);
    }
  }, [roles]);

  const resetModal = () => {
    setEmail(null);
    setFirstname(null);
    setLastname(null);
    setPassword(null);
    setPasswordConfirm(null);
    setRoleId(null);
    setErrorText(null);
  }

  const handleSubmit = async () => {
    setErrorText(null);

    try {
      let result = await adminService.createUser(
        email,
        firstname,
        lastname,
        password,
        passwordConfirm,
        roleId
      );

      await onHide(true, result);
      resetModal();
    } catch (err) {
      console.log(err);
      if (err && err.data && err.data.error) {
        setErrorText(err.data.error);
      } else {
        setErrorText("An error occurred");
      }
    }
  }

  const handleClose = async () => {
    await onHide(false);
    resetModal();
  }

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>Create User</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <Form.Label htmlFor="firstnameInput">Firstname</Form.Label>
            <Form.Control
              id="firstnameInput"
              type="text"
              value={firstname ? firstname : ""}
              onChange={(event) => {
                setFirstname(event.target.value);
              }}
              placeholder="Dave"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Label htmlFor="lastnameInput">Lastname</Form.Label>
            <Form.Control
              id="lastnameInput"
              type="text"
              value={lastname ? lastname : ""}
              onChange={(event) => {
                setLastname(event.target.value);
              }}
              placeholder="Noble"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Label htmlFor="emailInput">Email</Form.Label>
            <Form.Control
              id="emailInput"
              type="text"
              value={email ? email : ""}
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              placeholder="example@mps-data.co.uk"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Label htmlFor="roleInput">Role</Form.Label>
            <Form.Control
              id="roleInput"
              ref={dropdownRoleRef}
              onChange={(event) => {
                setRoleId(dropdownRoleRef.current.value);
              }}
              as="select"
            >
              {roles &&
                roles.map((x) => {
                  return <option value={x.id}>{x.name}</option>;
                })}
            </Form.Control>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Label htmlFor="newPasswordInput">Enter password</Form.Label>
            <Form.Control
              id="newPasswordInput"
              type="password"
              value={password ? password : ""}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              placeholder="Enter password"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Label htmlFor="newPasswordConfirmInput">
              Confirm password
            </Form.Label>
            <Form.Control
              id="newPasswordConfirmInput"
              type="password"
              value={passwordConfirm ? passwordConfirm : ""}
              onChange={(event) => {
                setPasswordConfirm(event.target.value);
              }}
              placeholder="Confirm password"
            />
          </Col>
        </Row>
        <Row>
          <Col>{errorLabel}</Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-danger"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={handleSubmit}
        >
          Create
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateUserModal;
